module.exports = __webpack_public_path__ + "static/media/logo_cn_invert_nl.978b73cd.svg";